import React, {useEffect} from 'react';

const RedirectPage = () => {
    useEffect(() => {
        const userAgent = navigator.userAgent.toLowerCase();

        const isIOS = /iphone|ipad|ipod/.test(userAgent);
        const isAndroid = /android/.test(userAgent);

        const appStoreUrl = 'https://apps.apple.com/it/app/locem/id6449721104';
        const googlePlayUrl = 'https://play.google.com/store/apps/details?id=com.locemsolutions.locem';
        const fallbackUrl = 'https://locemsolutions.com/';

        if (isIOS) {
            window.location.href = appStoreUrl;
        } else if (isAndroid) {
            window.location.href = googlePlayUrl;
        } else {
            window.location.href = fallbackUrl;
        }
    }, []);

    return (
        <div>
            <p>Reindirizzamento in corso...</p>
        </div>
    );
};

export default RedirectPage;
